/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Forgotten_DiscardInputs */

const en_us2_workout_live_forgotten_discard = /** @type {(inputs: Workout_Live_Forgotten_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard workout`)
};

const pt_br2_workout_live_forgotten_discard = /** @type {(inputs: Workout_Live_Forgotten_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar treino`)
};

const es_419_workout_live_forgotten_discard = /** @type {(inputs: Workout_Live_Forgotten_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar entrenamiento`)
};

const pt_pt2_workout_live_forgotten_discard = /** @type {(inputs: Workout_Live_Forgotten_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar treino`)
};

const fr_fr2_workout_live_forgotten_discard = /** @type {(inputs: Workout_Live_Forgotten_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner la séance`)
};

const de_de2_workout_live_forgotten_discard = /** @type {(inputs: Workout_Live_Forgotten_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training verwerfen`)
};

const it_it2_workout_live_forgotten_discard = /** @type {(inputs: Workout_Live_Forgotten_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarta allenamento`)
};

/**
* | output |
* | --- |
* | "Discard workout" |
*
* @param {Workout_Live_Forgotten_DiscardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_discard = /** @type {((inputs?: Workout_Live_Forgotten_DiscardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_DiscardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_discard(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_discard(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_discard(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_discard(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_discard(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_discard(inputs)
	return en_us2_workout_live_forgotten_discard(inputs)
});
export { workout_live_forgotten_discard as "workout-live.forgotten_discard" }